export default __webpack_public_path__ + "static/media/user-img.62c07627.svg";